import React from "react";
import { GAME_CONFIG } from "../config";

const RedOverlay = ({ foundHotspots, currentStage, isEligibleToNext }) => {
  return (
    <div
      className="red-eye-overlay"
      style={{
        opacity: foundHotspots[currentStage] == 4 && isEligibleToNext ? 0 : 0.3,
      }}
    ></div>
  );
};

const BlurOverlay = ({ foundHotspots, currentStage, isEligibleToNext }) => {
  return (
    <div
      className="blur-eye-overlay"
      style={{
        backdropFilter:
          foundHotspots[currentStage] == 4 && isEligibleToNext
            ? "blur(0px)"
            : "blur(2px)",
      }}
    ></div>
  );
};

export default function GameOverlay({
  currentStage,
  foundHotspots,
  isEligibleToNext = false,
}) {
  let overlays = GAME_CONFIG.hasPrepStage
    ? {
        1: (
          <RedOverlay
            foundHotspots={foundHotspots}
            isEligibleToNext={isEligibleToNext}
            currentStage={currentStage}
          />
        ),
        2: (
          <BlurOverlay
            foundHotspots={foundHotspots}
            isEligibleToNext={isEligibleToNext}
            currentStage={currentStage}
          />
        ),
        3: (
          <RedOverlay
            foundHotspots={foundHotspots}
            isEligibleToNext={isEligibleToNext}
            currentStage={currentStage}
          />
        ),
      }
    : {
        0: (
          <RedOverlay
            foundHotspots={foundHotspots}
            isEligibleToNext={isEligibleToNext}
            currentStage={currentStage}
          />
        ),
        1: (
          <BlurOverlay
            foundHotspots={foundHotspots}
            isEligibleToNext={isEligibleToNext}
            currentStage={currentStage}
          />
        ),
        2: (
          <RedOverlay
            foundHotspots={foundHotspots}
            isEligibleToNext={isEligibleToNext}
            currentStage={currentStage}
          />
        ),
      };

  return <>{overlays[currentStage]}</>;
}
